import { audioContext } from './context';

/**
 * A short, soft two-note sparkle when a codename letter appears (QA 2026-10-11: reveals went
 * unnoticed). Quiet and brief (about 0.3 s), so the listener's endpointer never takes it for the
 * child. Silent where Web Audio is unavailable.
 */
export function playChime(): void {
  let context: AudioContext;
  try {
    context = audioContext();
  } catch {
    return;
  }
  if (context.state !== 'running') return;
  const start = context.currentTime + 0.01;
  // E6 then B6: bright, consonant, and clear of the speech band's loudest part.
  [1318.5, 1975.5].forEach((frequency, i) => {
    const at = start + i * 0.09;
    const osc = context.createOscillator();
    const gain = context.createGain();
    osc.type = 'sine';
    osc.frequency.value = frequency;
    gain.gain.setValueAtTime(0, at);
    gain.gain.linearRampToValueAtTime(0.08, at + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.0001, at + 0.22);
    osc.connect(gain).connect(context.destination);
    osc.start(at);
    osc.stop(at + 0.24);
  });
}
